import { createFileRoute } from '@tanstack/react-router';
import { ThreadPane } from '@/features/conversations/ThreadPane';

export const Route = createFileRoute('/app/conversations/$conversationId/')({
  component: ConversationRoute,
  staticData: { title: 'Conversation' },
});

function ConversationRoute() {
  const { conversationId } = Route.useParams();
  return <ThreadPane key={conversationId} conversationId={conversationId} />;
}
